import moment from "moment";
import {
  getUserById,
  getBlockedUsersApi,
  registerUserApi,
  updateUserApi,
  unblockUserApi,
  createAlarmSettingApi,
  deleteUserApi,
} from "api/user";

// Firebase Firestore에서 커스텀 REST API (ddukddaki.com:4989) 로 이관.
// 기존 함수 시그니처와 반환 shape은 그대로 유지해 호출측 화면이 영향을 받지 않도록 한다.

/// ✅ 차단 데이터 가져오기
export const getBlockData = async (userDocId, setBlockData) => {
  try {
    const blockedData = await getBlockedUsersApi(userDocId);

    if (!setBlockData) {
      return blockedData;
    }

    if (blockedData && blockedData.length > 0) {
      setBlockData(blockedData);
    } else {
      setBlockData([]);
    }
  } catch (error) {
    console.error("failed getBlockData:", error);
    return;
  }
};

/// 로그인
export const login = async (id) => {
  try {
    const userData = await getUserById(id);
    return userData;
  } catch (error) {
    console.error("login failed : ", error);
    sessionStorage.removeItem("userData");
    localStorage.removeItem("userData");
    return [];
  }
};

/// 회원가입
export const register = async (body) => {
  try {
    const result = await registerUserApi({
      address: body["address"],
      addressDetail: body["addressDetail"],
      affiliation: body["affiliation"] || "",
      region: body["region"] || "",
      createDate: moment().format("YYYY-MM-DD HH:mm"),
      id: body["id"],
      material: body["material"],
      name: body["name"],
      phone: body["phone"],
      point: "0",
      rating: "0",
      token: "",
      userType: body["userType"],
    });

    if (result && result.success) {
      /// 알림 세팅 추가
      await createAlarmSettingApi({
        createDate: moment().format("YYYY-MM-DD HH:mm"),
        updateDate: "",
        docId: result.docId,
        id: body["id"],
        alarmState: [true, true],
      });
      sessionStorage.setItem("userData", JSON.stringify(body["id"]));
      localStorage.setItem("userData", JSON.stringify(body["id"])); // 자동 로그인
      return "success";
    }
    return "failed";
  } catch (error) {
    console.error("register failed", error);
    return "failed";
  }
};

/// 회원정보 수정
export const updateUser = async (userDocId, body) => {
  try {
    const result = await updateUserApi({
      docId: userDocId,
      address: body.address,
      addressDetail: body.addressDetail,
      phone: body.phone,
      material: body.material,
      affiliation: body.affiliation ?? "",
      region: body.region ?? "",
      token: body.token || "",
    });
    return !!(result && result.success);
  } catch (error) {
    console.error("updateUser failed", error);
    return false;
  }
};

/// 회원 탈퇴 (soft delete: userTB.deleteDate 기록 → 로그인 시 차단됨)
export const deleteAccount = async (userDocId) => {
  try {
    const result = await deleteUserApi(userDocId);
    return !!(result && result.success);
  } catch (error) {
    console.error("deleteAccount failed", error);
    return false;
  }
};

export const unBlockUser = async (userDocId, blockUserId) => {
  try {
    const result = await unblockUserApi(userDocId, blockUserId);
    return !!(result && result.success);
  } catch (error) {
    console.error("unBlockUser failed", error);
    return false;
  }
};
